import { AxleTableRow } from '@src/axles/AxleTableRow';
import type { VehicleType } from '@src/orders/domain/AxleSummary';
import type { AllAxlesInformation } from '@src/orders/PermitFormSections/axlesConfiguration/AxleInformationTypes';
import {
  type SetFieldValue,
  useFormContext,
  type UseFormGetValues,
} from 'react-hook-form';

type AxleRowProps = {
  index: number;
  isLoading?: boolean;
  fields: string[];
  disabledFields?: string[];
  vehicleType: VehicleType;
  vehiclePrefix?: string;
  /*oxlint-disable*/
  setValue: SetFieldValue<any>;
  getValue: UseFormGetValues<any>;
  /*oxlint-enable*/
  totalAxles: number;
  cumulativeAxleCount: number;
};

export const AxleInformationRow = (props: AxleRowProps) => {
  const { control } = useFormContext<AllAxlesInformation>();

  return (
    <AxleTableRow
      totalAxles={props.totalAxles}
      fields={props.fields}
      disabledFields={props.disabledFields ?? []}
      control={control}
      axleIndex={props.index}
      readonly={props.isLoading}
      cumulativeAxleCount={props.cumulativeAxleCount}
      vehicleType={props.vehicleType}
      vehiclePrefix={props.vehiclePrefix}
      setValue={props.setValue}
      getValue={props.getValue}
    />
  );
};
